// Init Theme and set prefix
import './theme.js';
// ======================================================================

import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-empty-placeholder.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import '@adornis/chemistry/elements/components/x-hr.js';
import '@adornis/chemistry/elements/components/x-loading-state.js';
import '@adornis/chemistry/elements/components/x-section.js';
import '@adornis/chemistry/elements/components/x-tabs.js';
import '@adornis/chemistry/elements/components/x-tree-view.js';
import { createComponentsFromChemistryBase } from '@adornis/chemistry/elements/x-components.js';
import '@adornis/data-view/client/x-data-view-card-list.js';
import '@adornis/data-view/client/x-data-view-table.js';
import '@adornis/data-view/client/x-data-view.js';
import '@adornis/data-view/client/x-sorting-card.js';
import '@adornis/datetime/x-date-picker-dropdown.js';
import '@adornis/dragdrop/x-drag-drop.js';
import '@adornis/field-management/x-field-selection-drawer.js';
import '@adornis/file-utils/client/x-file-input.js';
import '@adornis/file-utils/client/x-image.js';
import '@adornis/filter/client/x-filter-editor.js';
import '@adornis/forms/x-radiogroup.js';
import '@adornis/forms/x-textarea.js';
import '@adornis/internationalization/client/x-tel-input.js';
import '@adornis/popover/x-dropdown-multiselection.js';
import '@adornis/popover/x-dropdown-selection.js';
import '@adornis/popover/x-dropdown.js';
import '@adornis/tiptap/client/components/x-tiptap-action-bar-dropdown.js';
import '@adornis/tiptap/client/components/x-tiptap-action-bar.js';
import '@adornis/tiptap/client/x-tiptap.js';
import '@adornis/user-forms/x-login-input.js';
import './components/index.js';
import './fonts/index.js';

// buildify components (!IMPORTANT THAT IT IS IMPORTET AFTER /theme.js!)
import '@adornis/bh-buildify/theme/index.js';

createComponentsFromChemistryBase(
  'x-flex',
  'x-tabs',
  'x-tab',
  'x-image',
  'x-grid',
  'x-hr',
  'x-dropdown-multiselection',
  'x-dropdown-selection-content',
  'x-dropdown',
  'x-drag-drop',
  'x-date-picker-dropdown-content',
  'x-radiobutton',
  'x-radiogroup',
  'x-loading-state',
  'x-date-picker-dropdown',
  'x-basic-card',
  'x-login-input',
  'x-textarea',
  'x-file-input',
  'x-data-view-card-list',
  'x-sorting-card',
  'x-field-selection-drawer',
  'x-filter-editor',
  'x-tree-view',
  'x-drawer-panel',
  'x-tel-input',
  'x-empty-placeholder',
  'x-tiptap',
  'x-tiptap-action-bar',
  'x-tiptap-action-bar-dropdown',
  'x-stack-breadcrumb',
);
